export const INDEX_VOD_LIST = "INDEX_VOD_LIST";
export const INDEX_VOD_ADD_LIST = "INDEX_VOD_ADD_LIST";
export const VOD_LIST = "VOD_LIST";
export const VOD_LESSON_LIST = "VOD_LESSON_LIST";
export const GET_VOD_LESSON_SRC = "GET_VOD_LESSON_SRC";
export const GET_VOD_TENCENT_APPID = "GET_VOD_TENCENT_APPID";


// WEBPACK FOOTER //
// ./src/redux/type/Vod.type.js